import {isEmpty} from 'lodash';

import './styles.css';

import {NodeLabelColor} from 'src/types';

export const TypeLegend = ({nodeTypes, linkTypes}: {
  nodeTypes: Array<NodeLabelColor>, linkTypes: Array<NodeLabelColor>,
}) => {
  if (isEmpty(nodeTypes) && isEmpty(linkTypes)) {
    return <div className="TypeLegend"></div>;
  }

  return (
    <div className="TypeLegend">
      {!isEmpty(linkTypes) && (
        <>
          <h1>Relationships Legend</h1>
          <div className="TypeLegend__items">
            {linkTypes
                .filter((lt) => lt.type)
                .sort((a, b) => a.type.localeCompare(b.type))
                .map((lt) => (
                  <p key={lt.type}>
                    <span key={lt.type}
                      className="edge"
                      style={{background: lt.color || 'blue'}}
                    ></span>{' '}
                    {lt.type}
                  </p>
                ))}
          </div>
        </>
      )}

      {!isEmpty(nodeTypes) && (
        <>
          <h1>Items Legend</h1>
          <div className="TypeLegend__items">
            {nodeTypes
                .filter((nt) => nt.type)
                .sort((a, b) => a.type.localeCompare(b.type))
                .map((nt) => (
                  <p key={nt.type}>
                    <span key={nt.type} style={{background: nt.color}}></span> {nt.type}
                  </p>
                ))}
          </div>
        </>
      )}
    </div>
  );
};
